<div class="table-title">
    <ng-container>
        <span class="sectionTitle" stylePreference [textColor]="textColor"> {{ sectionTitle }} </span>
    </ng-container>
    <mat-icon class="edit-icon" (click)="editSectionTitle()" svgIcon="aumico-pattern-icon-edit-write"></mat-icon>
</div>
<div>
    <account-proof-swiss-display-component
        [mappingData]="sectionData"
        [noPreviousData]="noPreviousData"
        [printOptions]="printOptions"
        [pdfOptions]="pdfTronOptions"
    >
    </account-proof-swiss-display-component>
</div>
